// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"177":"home","913":"default"}[chunkId] + "." + __webpack_require__.h() + ".chunk.js";
};